module.exports = {
  OK: 'Xác nhận',
  CANCEL: 'Hủy bỏ',
  login_TITLE: 'Đăng nhập',
  login_USERNAME: 'Tên đăng nhập:',
  login_PASSWORD: 'Mật khẩu:',
  login_LANGUAGE: 'Ngôn ngữ:',
  login_SAVEPASSWORD: 'Lưu mật khẩu',
  login_failure: 'Tên đăng nhập hoặc mật khẩu không đúng.',
  main_title: 'Quản lý đại lý vận chuyển',
  main_user: 'Người dùng:',
  main_office: 'Công ty thuộc:',
  main_LOGOUT_TOOLTIP: 'Đăng xuất',
  main_CHANGE_PASSWORD_TOOLTIP: 'Thay đổi mật khẩu.',
  main_REFRESH_TOOLTIP: 'Cập nhật dữ liệu bộ nhớ đệm.',
  main_HELP_TOOLTIP: 'Trang trợ giúp.',
  main_LOADING_MODULE_STATUS: 'Đang tải {0} ...',
  main_INITIALIZING_STATUS: 'Đang tải ...',
  main_REFRESHING_STATUS: 'Đang cập nhật dữ liệu bộ nhớ đệm ...',
  password_title: 'Thay đổi mật khẩu',
  password_oldPassword: 'Mật khẩu cũ:',
  password_newPassword: 'Mật khẩu mới:',
  password_confirmTheNewPassword: 'Xác nhận mật khẩu mới:',
  password_confirmPassword: 'Nhập lại mật khẩu:',
  password_notMatch: 'Mật khẩu không khớp.',
  password_notCompliant: 'Mật khẩu phải dài 8–20 ký tự và bắt buộc có ít nhất một chữ số, một chữ hoa và một chữ thường.',
  password_noChange: 'Mật khẩu mới không được trùng với mật khẩu cũ.',
  password_failed: 'Thay đổi mật khẩu thất bại. Vui lòng kiểm tra lại mật khẩu và thử lại.',
  PleaseEnterAOldPassword: 'Vui lòng nhập mật khẩu cũ',
  PleaseEnterANewPassword: 'Vui lòng nhập mật khẩu mới',
  PleaseEnterTheConfirmationPassword: 'Vui lòng nhập xác nhận mật khẩu mới',
  TheNewPasswordDoesNotMatchTheConfirmedNewPassword: 'Mật khẩu mới và xác nhận mật khẩu không khớp',
  TheNewPasswordDoesNotMatchTheOldPassword: 'Mật khẩu mới không được trùng với mật khẩu cũ'
}
